<p-dialog [(visible)]="display" header="{{title}}" [modal]="true" [style]="{width: '70vw'}" (onHide)="closeModal()" [focusOnShow]="false" [styleClass]="'overflow-visible'">
  <form class="card mt-2" [formGroup]="form" (ngSubmit)="savePayableItemEdits()">
    <div class="card-body">
      <div class="row">
        <div class="col-12">

          <div class="row">
            <div class="col-4 d-flex align-items-center">
              <b>Date</b>
            </div>
            <div class="col-8">
              <input type="date" class="form-control mt-2" formControlName="dateString" />
              <app-validation-message [form]="form" [path]="'dateString'" [label]="'Date'"></app-validation-message>
            </div>
          </div>

          <div class="row">
            <div class="col-4 d-flex align-items-center">
              <b>Start Time</b>
            </div>
            <div class="col-8">
              <p-datepicker inputStyleClass="form-control mt-2" styleClass="w-100" panelStyleClass="calendarPanel" dataType="string" name="startTimeString" formControlName="startTimeString" [timeOnly]="true" [hourFormat]="12"></p-datepicker>
              <app-validation-message [form]="form" [path]="'startTimeString'" [label]="'Start Time'"></app-validation-message>
            </div>
          </div>

          <div class="row">
            <div class="col-4 d-flex align-items-center">
              <b>End Time</b>
            </div>
            <div class="col-8">
              <p-datepicker inputStyleClass="form-control mt-2" styleClass="w-100" panelStyleClass="calendarPanel" dataType="string" name="endTimeString" formControlName="endTimeString" [timeOnly]="true" [hourFormat]="12"></p-datepicker>
              <app-validation-message [form]="form" [path]="'endTimeString'" [label]="'End Time'"></app-validation-message>
            </div>
          </div>

        </div>
      </div>
    </div>
  </form>
  <ng-template pTemplate="footer">
    <div class="row w-100 m-0">
      <div class="col text-left pl-0">
        <button class="btn btn-secondary" type="button" (click)="closeModal()">Cancel</button>
      </div>
      <div class="col text-right pr-0">
        <button class="btn btn-primary" type="submit" (click)="savePayableItemEdits()" [disabled]="disableButtons">Save</button>
      </div>
    </div>
  </ng-template>
</p-dialog>
